var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EventDispatcher } from "../common/event";
import PenManager from "./PenManager";
import WebViewPen from "./WebViewPen";
let _webview_penmanager_instance = null;
const _active_pen = null;
export default class WebViewPenManager {
    constructor() {
        this.dispatcher = new EventDispatcher();
        this.getPen = (mac) => {
            const pen = PenManager.getInstance().getRegistedPen({
                mac: mac,
                webBluetoothId: WebViewPen.generateWebBluetoothId(),
                inputType: WebViewPen.getInputType(),
            });
            return pen;
        };
        this.onPenConnected = (e) => {
            const timeStamp = (e.timestamp ? e.timestamp : (new Date()).getTime());
            let pen = this.getPen(e.mac);
            if (!pen) {
                pen = PenManager.getInstance().createWebViewPen(e.mac);
            }
            pen.onConnected({ timeStamp, mac: e.mac });
        };
        this.onPenDisconnected = (e) => {
            const timeStamp = (e.timestamp ? e.timestamp : (new Date()).getTime());
            const pen = this.getPen(e.mac);
            if (pen) {
                pen.onDisconnected({
                    mac: e.mac,
                    timeStamp
                });
            }
        };
        this.onPenDown = (e) => {
            let pen = this.getPen(e.mac);
            console.log("onPenDown getPen : ", pen, e.mac);
            if (!pen) {
                pen = PenManager.getInstance().createWebViewPen(e.mac);
                // 1. pen 이 없거나
                // 2. view 가  event 못받음
                // 3. pens 가 세팅이 되었는지
                console.log("onPenDown createWebViewPen : ", pen, pen.mac);
            }
            const timeStamp = (e.timestamp ? e.timestamp : (new Date()).getTime());
            pen.onPenDown({
                timeStamp: timeStamp,
                penTipMode: e.penTipMode,
            });
            pen.onPageInfo({
                timeStamp: timeStamp,
                section: e.pageInfo.section,
                owner: e.pageInfo.owner,
                book: e.pageInfo.book,
                page: e.pageInfo.page
            }, false);
        };
        this.onPenMove = (e) => {
            const timeStamp = (e.timestamp ? e.timestamp : (new Date()).getTime());
            const pen = this.getPen(e.mac);
            if (pen) {
                console.log("pen dot force : ", e.f);
                pen.onPenMove({
                    timeStamp: timeStamp,
                    x: e.x,
                    y: e.y,
                    force: e.f,
                    timediff: e.deltaTime,
                });
            }
        };
        this.onPenUp = (e) => {
            const timeStamp = (e.timestamp ? e.timestamp : (new Date()).getTime());
            const pen = this.getPen(e.mac);
            if (pen) {
                pen.onPenUp({ timeStamp });
            }
        };
        this.handleConnectPen = (mac) => __awaiter(this, void 0, void 0, function* () {
            // TODO: 여기에 SDK의 connect function을 부를 것
            return false;
        });
        this.handleDisconnectPen = (mac) => {
            // TODO: 여기에 SDK의 disconnect function을 부를 것
        };
        this.addEventListener = (eventName, listener) => {
            this.dispatcher.on(eventName, listener, null);
        };
        /**
         *
         * @param eventName
         * @param listener
         */
        this.removeEventListener = (eventName, listener) => {
            this.dispatcher.off(eventName, listener);
        };
        if (_webview_penmanager_instance) {
            return _webview_penmanager_instance;
        }
        window.onPenDown = this.onPenDown;
        window.onPenMove = this.onPenMove;
        window.onPenUp = this.onPenUp;
        window.onPenConnected = this.onPenConnected;
        window.onPenDisconnected = this.onPenDisconnected;
    }
    static getInstance() {
        if (!_webview_penmanager_instance) {
            _webview_penmanager_instance = new WebViewPenManager();
        }
        return _webview_penmanager_instance;
    }
}
// 초기화
export const webViewPenManager = (function () {
    return WebViewPenManager.getInstance();
})();
//# sourceMappingURL=WebViewPenManager.js.map